import owd from '../owd/owd';

export default class CursorTheme extends owd.Component {
	init() {
        this.app.getModule('customCursor').addModifier(this.$element[0]);

        this.on('bg-color-changed', (e, color) => {
            if (color !== this.lastColor) {
                if (color == 'rgb(0, 0, 0)') {
                    this.$element[0].dataset.cursorTheme = 'dark';
                } else {
                    this.$element[0].dataset.cursorTheme = 'light';
                }

                this.$element[0].dispatchEvent(new Event('cursor-modifier-changed'));

                this.lastColor = color;
            }

        })
	}

    destroy() {
        super.destroy();
        this.app.getModule('customCursor').removeModifier(this.$element[0]);
    }
}

owd.registerComponent('cursor-theme', {
	component: CursorTheme
});
